export const HTTP_STATUS = {
  OK: 200,
  CREATED: 201,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  // Share-token revoked/expired — the public Live Wall endpoint returns
  // 410 Gone so anonymous viewers see a clear "link no longer active"
  // empty-state instead of a generic 404.
  GONE: 410,
  SERVER_ERROR: 500,
}
